var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('example-overlay',{attrs:{"is-example":_vm.docs.isExample,"edit-link":"/edit#documents"}},[_c('documents-folder',{attrs:{"folder":_vm.tree,"expanded":true,"is-example":_vm.docs.isExample}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }